import React from 'react';

require('stylesheets/boilerplate/divider');

const Divider = React.createClass({
  render() {
    return (
      <div className="divider"></div>
    );
  },
});
export default Divider;



/** WEBPACK FOOTER **
 ** ./app/scripts/components/boilerplate/divider.jsx
 **/